import styled from '@emotion/styled';
import {colors, sizes} from 'patient-ping-remedy/packages/theme';
import {StandardSemiBoldTypography} from "patient-ping-remedy/packages/typography";

export const SummaryWrapper = styled.div`
  background: ${colors.white};
  border: 1px solid ${colors.gray3};
  border-radius: 0.8rem;
  margin-bottom: ${sizes.small};
  padding: ${sizes.small};
`;

export const SummaryHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${sizes.xSmall};
  cursor: pointer;
  user-select: none;
  gap: ${sizes.xSmall};
`;

export const SummaryTitle = styled(StandardSemiBoldTypography)`
`;

export const ArrowWrapper = styled.div`
  margin-left: auto;
`;

export const CollapsedSummaryText = styled.span`
  color: ${colors.charcoal};
  margin-left: ${sizes.small};
`;

export const TilesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1.6rem;
`;

export const Tile = styled.button<{ active?: boolean; small?: boolean }>`
  display: grid;
  justify-items: start;
  align-content: center;
  overflow: hidden;
  width: ${({ small }) => small ? '17.1rem' : '19.25rem'};
  padding: ${({ small }) => small ? '1.2rem' : '2.4rem'};
  gap: 0.8rem;
  border: 1px solid ${({ active }) => active ? colors.primary1 : colors.gray3};
  border-radius: 0.8rem;
  cursor: pointer;
  background: ${({ active }) => active ? colors.blue1 : colors.white};

  & > * {
    min-width: 0;
    max-width: 100%;
  }

  &:hover, &:focus-visible {
    border-color: ${colors.primary1};
  }
`;

export const TilesDivider = styled.div`
  width: 1px;
  align-self: stretch;
  background: ${colors.gray3};
`;

export const StaticTileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 1.6rem;
`;

export const PinnedTileContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1.6rem;
`;

export const TileCount = styled.div`
  font-size: 3.2rem;
  font-weight: 700;
  color: ${colors.primary1};
`;

export const TileLabel = styled.div`
  font-size: 1.6rem;
  color: ${colors.charcoal};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
  max-width: 100%;
`;
